import Swiper, {Pagination, Lazy, Autoplay, Navigation} from "swiper";

export default function BlockSliderBoxes() {
	if(document.querySelector('.slider-boxes__swiper')) {
		Swiper.use( [Pagination, Lazy, Autoplay, Navigation] );
		const swiper = new Swiper( '.slider-boxes__swiper', {
			speed: 800,
			slidesPerView: parseInt(
				document.querySelector( '.slider-boxes__swiper' ).dataset.columns ),
			spaceBetween: 30,
			breakpoints: {
				// when window width is >= 320px
				0: {
					slidesPerView: 1,
					spaceBetween: 0
				},
				// when window width is >= 480px
				// when window width is >= 640px
				480: {
					slidesPerView: 2,
					spaceBetween: 20
				},
				992: {
					slidesPerView: 3,
					spaceBetween: 30
				},
				1200: {
					slidesPerView: 4,
					spaceBetween: 30
				}
			},
			loop: false,
			autoplay: {
				delay: 5000,
				disableOnInteraction: true,
			},
			preloadImages: true,
			lazy: {
				loadPrevNext: true,
			},
			navigation: {
				nextEl: '.slider-boxes__nav--next',
				prevEl: '.slider-boxes__nav--prev',
			},
		} );
	}
}
